module.exports = __webpack_public_path__ + "static/media/468x60_0018_ru.147713e1.jpg";